export default __webpack_public_path__ + "static/media/tv-new.510dcc04.svg";